import { create } from 'zustand'

export const useEstadiasStore = create((set) => ({
    dataEstadias: [],
    filtros: {
        estadia_tiempo: {},
        estadia_ubicacion: {}
    },
    setDataEstadias: (data) => {
        set((state) => ({
            dataEstadias: data
        }))
    },
    setFiltroEstadiaTiempo: (filtro) => {
        set((state) => ({
            filtros: { ...state.filtros, estadia_tiempo: filtro }
        }))
    },
    setFiltroEstadiaUbicacion: (filtro) => {
        set((state) => ({
            filtros: { ...state.filtros, estadia_ubicacion: filtro }
        }))
    },
    reiniciar: () => {
        set({
            datos: [],
            progresoCargado: 0,
            totalDatos: 0,
            cargando: false,
            error: null,
            paginaActual: 1,
            totalPaginas: 1,
            datosCargados: 0,
            paginasNoCargadas: [],
            cargaCompletada: false,
            tieneError: false
        });
    }
    
}))